<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

const i18n = getI18n()

const props = defineProps({
  showArchived: {
    type: Boolean,
    default: false,
  },
  gridRef: Object,
})

const emit = defineEmits(['update:showArchived'])

const _showArchived = ref(props.showArchived)

const onToggleArchived = async() => {
  _showArchived.value = !_showArchived.value
  emit('update:showArchived', _showArchived.value)
  props.gridRef.instance.refresh()
}

</script>
<template>
  <q-toggle
    :model-value="_showArchived"
    :label="i18n.t('common.showArchived')"
    color="primary"
    style="transform: translateY(0.0625rem);"
    @update:model-value="onToggleArchived"
  />
</template>
